<template>

    <div class="d-flex justify-content-start  align-items-center my-3 gap-2 header-container">
        <img src="../../../assets/images/title-icon.png" alt="">
        <h3 class="m-0">Review Template</h3>
        
    </div>

    <div class="content">
        <div>
            <div class="name-discribtion-container align-items-center">
                <div class=" d-flex content-border gap-3">
                    <div class="name-title">
                        <h6>Name</h6>
                    </div> 
                    <div class="details">
                        <p>{{template['name']}}</p>
                    </div>
                </div>

                <div class=" d-flex content-border gap-3">
                    <div class="name-title">
                        <h6>Description</h6>
                    </div>
                    <div class="details">
                        <p class="description-container">{{template['description']}}</p>
                    </div>    
                </div>
            </div>
            <div class="question-types-container ">
                <div class=" d-flex gap-3 content-border ">
                    <div class="question-types-header">
                        <h6>Questions Types</h6>
                    </div>
                    <div class="d-flex styleQyestionTypes">
                        <ul class="ulDesign1">
                            <li v-for="type in questionsTypes" :key="type">
                                <p style="display: contents">{{type}}</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <QuestionsComponent @weight="onWeight" :template="template"/>
        <div class="d-flex justify-content-start gap-2 align-items-center content-border">
            <label for="q-weight">Weight Per Question</label>
            <input id="q-weight" autocomplete="off" type="number" min="0" class="weight-style" :value="weight"/>
        </div>
    </div>
    <router-link class="back-route" to="" @click="$router.go(-1)">
            <button class="back-btn">Back</button>
    </router-link>

</template>

<script>
    import {onMounted, ref} from "vue";
    import repository from "../../../api-services/repository";
    import {useRoute} from "vue-router";
    import QuestionsComponent from "./commonCoponents/questions";
    import getQuestionType from "../../../helpers/getQuestionType";
    import getQuestionName from "../../../helpers/getQuestionName";
    import router from "../../../router";
    import {useStore} from "vuex";

    export default {
        name: 'app',
        components: {QuestionsComponent},
        setup() {
            const store = useStore();
            const route = useRoute();
            const template = ref({
                name: '',
                description: '',
                questions: {
                    trueOrFalse: {
                        weight: 0,
                        title:'True Or False',
                        questions: [

                        ],
                    },
                    multipleChoices: {
                        weight: 0,
                        title:'Multiple Choice',
                        questions: [
                        ]
                    },
                    freeText: {
                        weight: 0,
                        title:'Free Text',
                        questions: [

                        ],
                    },
                    slides: {
                        weight: 0,
                        title:'Slides',
                        name: '',
                        description: '',
                        images: [],
                        category: []
                    },
                    rank: {
                        weight: 0,
                        title:'Rank',
                        questions: [

                        ],
                    },
                    arrange: {
                        weight: 0,
                        title:'Arrange',
                        questions: [

                        ],
                    },
                }
            });

            const questionsTypes = ref([]);
            const weightFlag = ref(false);
            const types = ref([]);
            const weight = ref(0);
            const title = ref('');
            const templateId = route.params.id;

            onMounted(async () => {
                try {
                    let templateData = await repository.view('templates', templateId);
                    await formatData(templateData.data.data);

                    await types.value.forEach((item) => {
                       if(item !== 'slides' &&  template.value.questions[item]['questions'].length > 0){

                           if(!weightFlag.value){
                               weight.value = template.value.questions[item].weight;
                               weightFlag.value = true
                           }
                       }else if(item === 'slides'){

                           if(!weightFlag.value){
                               weight.value = template.value.questions[item].weight;
                               weightFlag.value = true
                           }
                       }

                    })

                } catch (e) {
                    if (process.env.VUE_ENV === 'development')
                    console.log({e})
                }
            });

            const formatData = (data) => {
                let type = null;
                data.questions.forEach((q) => {
                    let qName = null;
                    // questionsTypes.value.push(q.title);

                    if (questionsTypes.value.indexOf(q.title) === -1) {
                        questionsTypes.value.push(q.title);
                    }

                    type = getQuestionType(q.type);
                    qName = getQuestionName(q.type);

                    // if(!questionsTypes.value.includes(qName))
                    //     questionsTypes.value.push(qName)

                    template.value.questions[type].questions = [];
                });

                template.value.name = data.name;
                template.value.description = data.description;

                data.questions.forEach((q) => {
                    type = getQuestionType(q.type);
                    template.value.questions[type].weight = q.weight;
                    template.value.questions[type].title = q.title;

                    q.answers.forEach((ans) => {
                        ans.is_correct = ans.is_correct === 1;
                    });

                    if (( (type === 'freeText'))) {


                        template.value.questions[type].questions.push(
                            {
                                question: q.content,
                                answer: q.answers[0].value,
                            }
                        )
                    } else {
                        template.value.questions[type].questions.push(
                            {
                                question: q.content,
                                answers: q.answers
                            }
                        )
                    }
                });

                data.slides.forEach((slide) => {

                    // if(!questionsTypes.value.includes('Slides'))
                    //     questionsTypes.value.push('Slides')
                    questionsTypes.value.push(slide.title);

                    template.value.questions['slides'].weight = slide.weight;
                    template.value.questions['slides'].title = slide.title;
                    template.value.questions['slides'].name = slide.name;
                    template.value.questions['slides'].description = slide.description;
                    template.value.questions['slides'].images = slide.attachments;
                    template.value.questions['slides'].category = slide.categories;
                })

                if (process.env.VUE_ENV === 'development')
                console.log('temp => ', template.value)
            };

            const onWeight = (e) => {
                weight.value = e;
                if (process.env.VUE_ENV === 'development')
                console.log({e});
            };

             const backHandler = async () => {
                 await router.push('/' + store.state.settings.currentRoute);
            };

            return {
                template,
                questionsTypes,
                weight,
                weightFlag,
                types,
                formatData,
                onWeight,
                backHandler
            }
        }
    }
</script>

<style scoped>
    .header-container{
        padding-inline: 30px;
        text-transform: uppercase;
    }
    .back-route{
        margin-top: 2vh;
        display: flex;
        justify-content: end;
        width:100%;
        height: 35px;
        padding-inline: 30px;
    }
    .back-btn{
        background-color: #707070 !important;
        padding: 0px 50px;
        text-decoration: none;
        cursor: pointer;
        color: #FFF;
        font-size: 18px;
        border: 0;
        border-radius: 5px;
    }
    .question-types-container,
    .name-discribtion-container{
        padding: 30px;
        border-radius: 5px;
        background-color: #023144;
        border: 1px solid rgba(200, 200, 200,0.1);
        gap:20px !important;
        margin-bottom: 20px;
    }
    .styleQyestionTypes{
        background-color:#022B3C ;
        border: 1px solid rgba(200, 200, 200,0.1);
        padding-inline: 10px;
        width: 90%;
        border-radius: 5px;
        align-items: center;
        overflow-x: auto;
    }

    .ulDesign1 {
        width: 100%;
        list-style: none;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 20px;
        margin: 0;
        padding: 0;
        overflow-x: auto;
    }
    .ulDesign1 li{
        white-space: nowrap;
    }

    .ulDesign1 li::before {
        content: "\2022";
        color: #e65c00;
        font-weight: bold;
        font-size: 20px;
        display: inline-block;
        width: 1em;
        
    }

    #q-weight{
        pointer-events: none;
    }
    .description-container {
        overflow-y: auto;
    }
    .content-border{
        margin-bottom: 10px;
        min-height: 40px;
    }
    .question-types-header{
        background-color:#37A6A2 ;
        padding-inline: 10px;
        width:200px;
        border-radius: 5px;
        display: flex;
        align-items: center;
        height: 45px;
    }

    .content-border .name-title {
        background-color:#37A6A2 ;
        padding-inline: 10px;
        width:130px;
        border-radius: 5px;
        display: flex;
        align-items: center;
    }
    .question-types-header h6,
    .name-title h6{
        margin: 0;
    }
    .content-border .details {
        padding-block: 5px;
        background-color:#022B3C ;
        padding-inline: 10px;
        border-radius: 5px;
        width: 90%;
        display: flex;
        align-items: center;
        border: 1px solid rgba(200, 200, 200,0.1);
    }
    .details p{
        margin: 0;
        padding: 0;
    }

    .content {
        margin-inline: 30px;
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding: 30px;
        height: 65vh;
        overflow-y: auto;
        border-radius: 10px;
        background-color: #022B3C;
    }


    .weight-style {
        background-color: transparent;
        border: 1px solid #39525C;
        border-radius: 4px;
        width: 86px;
        height: 32px;
        color: var(--main-color);
        padding: 10px;
    }


    /* textarea {
        height: 200px;
        min-height: 200px;
        max-height: 250px;
    } */
</style>